import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Route, Routes } from "react-router-dom";

import { db } from "./firebase";
import { Loader } from "./helper/loader";
import ProtectedRoutes from "./helper/secureRoute";
import EventCheckout from "./pages/EventCheckout";
import EventPartnerCheckout from "./pages/EventPartnerCheckout";
import EventTicketing from "./pages/EventTicketing";
import EventTicketingPartner from "./pages/EventTicketingPartner";
import PageNotFound from "./pages/PageNotFound";
import Politics from "./pages/Politics";
import Subscribe from "./pages/Subscribe";
import DashboardRouter from "./pages/dashboardPages/dashboardRoute";
import { ForgetPass } from "./pages/forgetPass/forgetPass";
import { Login } from "./pages/login/login";
import SignUp from "./pages/signup/Signup";
import userAction from "./redux/users/action";
import Takeaway from "./pages/takeaway/takeaway/Takeaway";
import TakeawaySuccess from "./pages/takeaway/takeawaySuccess/TakeawaySuccess";
import Cashless from "./pages/cashless/Cashless";
import CashlessPayment from "./pages/cashless/CashlessPayment";
import CashlessSuccess from "./pages/cashless/CashlessSuccess";
import CashlessServed from "./pages/cashless/CashlessServed";
import CashlessPanier from "./pages/cashless/CashlessPanier";
import InvoiceCheckout from "./pages/invoice/InvoiceCheckout";
import InvoiceSuccess from "./pages/invoice/InvoiceSuccess";
import InvoiceCanceled from "./pages/invoice/InvoiceCanceled";
import CheckFunds from "./pages/cashless-cards/CheckFunds";

const Router = () => {
  const dispatch = useDispatch();
  const { setUser } = userAction;
  const [loader, setLoader] = useState(true);

  const checkUserLoggedIn = async () => {
    const auth = getAuth();
    await onAuthStateChanged(auth, async (user) => {
      setLoader(true);
      if (user) {
        const userId = user.uid;
        const userRef = doc(db, "Store", userId);
        let loadedUser;

        await getDoc(userRef)
          .then((snapshot) => {
            const data = {
              id: snapshot.id,
              ...snapshot.data(),
            };
            loadedUser = data;
          })
          .catch((err) => {
            console.log("Fetch user failed: " + err);
          });

        dispatch(setUser(loadedUser));
        setLoader(false);
      } else {
        console.log("User is signed out");
        setLoader(false);
      }
    });
  };
  useEffect(() => {
    checkUserLoggedIn();
  }, []);

  return (
    <>
      <Routes>
        <Route path="/inscription" element={<Subscribe />} />
        <Route path="/checkout/:eventId/partner-order/:orderId/:paymentStatus" element={<EventPartnerCheckout />} />
        <Route
          path="/checkout/:eventId/:participantId/:paymentStatus"
          element={<EventCheckout />}
        />
        <Route path="/events/:eventId" element={<EventTicketing />} />
        <Route path="/events/:eventId/partner/:partnerId" element={<EventTicketingPartner />} />
        <Route exact path="/politics" component={Politics} />
        <Route path="/:page" element={<PageNotFound />} />
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/forget-password" element={<ForgetPass />} />
        <Route element={<ProtectedRoutes />}>
          <Route exact path="/dashboard/:next" element={<DashboardRouter />} />
          <Route exact path="/dashboard/marketplace/:providerId" element={<DashboardRouter />} />
        </Route>
        <Route path="/checkfunds" element={<CheckFunds />} />
        <Route path="/checkfounds" element={<CheckFunds />} />
        <Route path="/cashless/:orgId" element={<Cashless />} />
        <Route path="/cashless/:orgId/cart" element={<CashlessPanier />} />
        <Route path="/cashless/:orgId/payment" element={<CashlessPayment />} />
        <Route path="/cashless/:orgId/order/:orderId/success" element={<CashlessSuccess />} />
        <Route path="/cashless/:orgId/order/:orderId/canceled" element={<CashlessServed />} />
        <Route path="/invoice/:invoiceId" element={<InvoiceCheckout />} />
        <Route path="/invoice/success" element={<InvoiceSuccess />} />
        <Route path="/invoice/canceled" element={<InvoiceCanceled />} />
        <Route path="/takeaway/:orgId" element={<Takeaway />} />
        <Route path="/takeaway/:orgId/order/:orderId" element={<TakeawaySuccess />} />
      </Routes>
      {loader && <Loader loader={loader} />}
    </>
  );
};

export default Router;
